/**
 * Seção "Canais" das configurações — administração do `Actuar.ChannelGateway`.
 *
 * É uma seção nova e não uma aba dentro de "WhatsApp": a tela legada fala com o
 * `whatsappservice-api` por sessão de QR Code, um número por tenant. Esta fala com
 * a Cloud API oficial da Meta, com WABA, número, template e cota. Os dois convivem
 * enquanto a migração não acontece.
 */
export enum EChannelsIds {
  CONNECTIONS = 'connections',
  TEMPLATES = 'templates',
}

export const channelsPageFragments = [
  {
    title: 'CHANNEL_GATEWAY.CONNECTIONS.TITLE',
    id: EChannelsIds.CONNECTIONS,
    adminScopeOnly: true,
  },
  {
    title: 'CHANNEL_GATEWAY.TEMPLATES.TITLE',
    id: EChannelsIds.TEMPLATES,
    adminScopeOnly: true,
  },
];
